import { render } from "./forgetPassword.vue?vue&type=template&id=62ff3d09&scoped=true"
import script from "./forgetPassword.vue?vue&type=script&lang=js"
export * from "./forgetPassword.vue?vue&type=script&lang=js"

import "./forgetPassword.vue?vue&type=style&index=0&id=62ff3d09&lang=scss&scoped=true"

import exportComponent from "C:\\wamp64\\www\\DDP\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62ff3d09"]])

export default __exports__